/**
 * Whether the parent EV experiment should force the top banner
 * (`dashboard_soft_gate` only).
 *
 * Kept separate from GraphQL `showBanner`, which is the soft-prompt for existing users
 * (`emailVerificationRequired = false`).
 */
import { currentUserIsCorporate, currentUserIsParent } from '@/apps/verifyEmail/helpers/paths';
import {
  getParentEmailVerificationPlacement,
  shouldRequireParentEmailVerificationNow,
} from '@/apps/verifyEmail/helpers/parentPlacementPolicy';

export function shouldForceParentExperimentEmailVerificationBanner(
  verified: boolean,
  emailVerificationRequired: boolean
): boolean {
  if (!emailVerificationRequired) {
    return false;
  }

  return shouldRequireParentEmailVerificationNow({
    verified,
    isParent: currentUserIsParent(),
    isCorporate: currentUserIsCorporate(),
    emailVerificationRequired,
    placement: getParentEmailVerificationPlacement(),
    moment: 'dashboard',
    restriction: 'soft',
  });
}
